import "core-js/modules/es.symbol.description.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-642b651c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "goods trades"
};
const _hoisted_2 = {
  class: "fadeInUp",
  wait: "200"
};
const _hoisted_3 = {
  class: "tabs-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tabs-ink"
}, null, -1));
const _hoisted_5 = {
  key: 0,
  class: "con-box"
};
const _hoisted_6 = {
  class: "flexbox"
};
const _hoisted_7 = {
  class: "pic fadeInLeft"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "context fadeInRight"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "con-box"
};
const _hoisted_12 = {
  class: "flexbox"
};
const _hoisted_13 = {
  class: "pic"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "context"
};
const _hoisted_16 = {
  class: "title"
};
import { ref, reactive, onMounted, watch, computed } from 'vue';
import { isMobile, tabHoverIndex, observe } from '@/utils';
export default {
  __name: 'index',
  props: {
    source: {
      type: String,
      default: '首页'
    },
    header: {
      type: String,
      default: '场景解决方案'
    },
    data: {
      type: Array,
      default: [{
        key: 't1',
        tab: '司法检行业',
        title: '科技强检，助力打造智慧检务',
        imgSrc: require('./img/sifa.jpg'),
        description: '助力司法检行业提高执法办案质效。突破纸质签名带来的办案困难、安全性不足等局限，通过法律文书电子化、数字笔迹AI识别技术，实现“法律文书”全流程线上流转；链式加密存证结合同步音像采集，杜绝“代签”、“补签”，确保签署行为真实有效，支持事后随时调查举证。'
      }, {
        key: 't2',
        tab: '金融行业',
        title: '科技创新，打造智慧金融新模式',
        imgSrc: require('./img/jinrong.jpg'),
        description: '基于数字笔迹手写电子签名数据采集及笔迹生物特征识别，运用区块链技术存证，实现银行柜面凭证、信贷业务合同签署各方主体身份真实可信及签署文档合法有效，完全满足银行柜面、信贷业务无纸化的各项需求。'
      }, {
        key: 't3',
        tab: '燃气行业',
        title: '科技赋能，燃气行业业务电子化',
        imgSrc: require('./img/ranqi.jpg'),
        description: '提供具备低耦合、灵活部署等特性的应用平台，能与燃气集团现有系统业务对接协作。在数字笔迹手写电子签名技术基础上，结合人工智能技术、区块链，真正实现法律逻辑严谨、司法处置便利。全面赋能燃气相关业务纸质文件电子化，电子文档证据化。'
      }, {
        key: 't4',
        tab: '地产行业',
        title: '科技助兴，助推房地产高速营销',
        imgSrc: require('./img/dichan.jpg'),
        description: '实现房地产交易网签无纸化应用，可优化商品房交易业务办理流程，创新探索商品房网签“全程无纸化、流程服务办理化机档案电子化”的业务办理和管理，助力业务提效签约，助推房产新兴复苏。'
      }]
    }
  },
  setup(__props) {
    const props = __props;
    const tab3 = ref('t1');
    const trackOption = computed(() => {
      return {
        button_name: '立即体验',
        click_info: `${props.source}_${props.header}`,
        event_source: `${props.source}`,
        event_source_pam: `${props.header}`,
        event_target: '亲笔签登录页',
        event_target_pam: null
      };
    });
    const tabs = ref(null);
    onMounted(() => {
      if (!isMobile() && tabs.value) {
        tabHoverIndex(tabs.value, index => {
          const key = 't' + (index + 1);
          if (tab3.value !== key) {
            tab3.value = key;
          }
        });
      }
      [...document.querySelectorAll('.trades .ant-tabs-nav')].forEach(target => {
        target.className += ' fadeInUp';
      });
      observe(['.fadeInUp']);
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_var_tab_item = _resolveComponent("var-tab-item");
      const _component_var_tabs_items = _resolveComponent("var-tabs-items");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(props.header), 1), _createVNode(_component_a_tabs, {
        activeKey: tab3.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => tab3.value = $event),
        ref_key: "tabs",
        ref: tabs,
        "force-render": true
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, item => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.key,
            "force-render": true
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(item.tab), 1), _hoisted_4])]),
            default: _withCtx(() => [!_unref(isMobile)() ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
              src: item.imgSrc
            }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1), _createElementVNode("p", null, _toDisplayString(item.description), 1)])])])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["activeKey"]), _unref(isMobile)() ? (_openBlock(), _createBlock(_component_var_tabs_items, {
        key: 0,
        active: tab3.value,
        "onUpdate:active": _cache[1] || (_cache[1] = $event => tab3.value = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, item => {
          return _openBlock(), _createBlock(_component_var_tab_item, {
            key: item.key,
            name: item.key
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
              src: item.imgSrc
            }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1), _createElementVNode("p", null, _toDisplayString(item.description), 1)])])])]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["active"])) : _createCommentVNode("", true)]);
    };
  }
};